import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from 'primeng/api';
import { TranslatorPipe } from '../services/translator.pipe';

@Component({
  selector: 'app-reminder-modal',
  templateUrl: './reminder-modal.component.html',
  styleUrls: ['./reminder-modal.component.scss'],
  providers: [MessageService]
})
export class ReminderModalComponent implements OnInit {

  @Input() startDate: string = '16-07-2024 00:00:00'; // Default value for testing
  @Input() type!: string;
  @Input() _id!: string;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  days: number = 1;
  date: Date | null = null;
  minSelectableDate: Date | any;
  maxSelectableDate: Date | any;
  private translator: TranslatorPipe = new TranslatorPipe();

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.updateDateLimits();
    this.getDateData()
  }

  async getDateData() {
    let res = await this.dataService.getData('reminder/' + this._id);
    if (res.error) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate('Failed to get reminder data') });
    }

    if (res.data) {
      this.days = res.data.daysBefore;
      this.date = new Date(res.data.date);
    }
  }

  updateDateLimits() {
    if (!this.startDate) return;

    // Convert "16-07-2024 00:00:00" to Date object
    const [day, month, year] = this.startDate.split(" ")[0].split("-").map(Number);
    this.maxSelectableDate = new Date(year, month - 1, day); // Original start date

    // Subtract 'days' from startDate
    if (this.days && this.days > 0) {
      let calculatedDate = new Date(this.maxSelectableDate);
      calculatedDate.setDate(this.maxSelectableDate.getDate() - this.days);
      this.date = calculatedDate;
    } else {
      this.minSelectableDate = null;
    }
  }

  dateValidate(selectedDate: Date) {
    if (!this.maxSelectableDate || !selectedDate) return;
    // Ensure selected date is between min and max date
    if (selectedDate < (this.minSelectableDate || new Date(0)) || selectedDate > this.maxSelectableDate) {
      this.date = null;
    }
  }

  disableDates(date: any): boolean {
    const selectedDate = new Date(date.year, date.month - 1, date.day);

    if (!this.maxSelectableDate || !selectedDate) return false;

    if (selectedDate < (this.minSelectableDate) || selectedDate > this.maxSelectableDate) {
      return false
    }

    return true
  }

  async submit() {
    let data: any = {
      type: this.type,
      date: this.date,
      daysBefore: this.days
    }

    if (this.type == 'SURVEY') {
      data.surveyId = this._id;
    } else if (this.type == 'ASSESSMENT') {
      data.assessmentId = this._id;
    } else {
      data.trainingId = this._id;
    }

    let res = await this.dataService.postData("reminder", data);
    if (!res.error) {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate('Reminder set successfully') });
      this.close.emit(true);
      return;
    }
    this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate('Failed to set reminder') });
  }

  translate(text: string) {
    return this.translator.transform(text);
  }
}
